<div class="login-holder">
    <div class="text-container mat-elevation-z8">
        <p class="centered-text">Välkommen till tjänsten för avtalssignering. För att kunna använda tjänsten behöver
            fotografen först identifiera sig med BankID.</p>
        <aku-bankid [bankIdUrl]="bankIdUrl" (accessToken)="configService.setToken($event)"></aku-bankid>
    </div>
</div>
